import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useSWR from 'swr';
import RoleEnum from '../ts/enum/role.enum';
import useAuth from './useAuth';
import useDomain from './useDomain';
import useLocalization from './useLocalization';

const useDirection = (key: string = 'direction') => {
  const { t } = useTranslation();
  const { setLanguage, getLanguage, getCurrency } = useLocalization();
  const {
    location: { pathname },
  } = useHistory();
  const { symbol_native } = useDomain();
  const { hasRole } = useAuth();
  // const { data: domainConfig } = useSWR(`/domain/config`, {
  //   onSuccess: (data) => {
  //     const { primaryColor, language, languageKey, isRtl } = data;

  //     primaryColor &&
  //       window?.less?.modifyVars({ "@primary-color": primaryColor });
  //     const lang = getLanguage()?.language;

  //     // @ts-ignore
  //     const lang01 = JSON.parse(localStorage.getItem("localization"))?.language;

  //     if (!lang || !lang01) {
  //       if (language) {

  //         setLanguage(language, languageKey, isRtl);
  //       }
  //     }
  //   },
  // });

  // const lng = localStorage.getItem("lng");
  const lng =
    // @ts-ignore
    JSON.parse(localStorage.getItem('localization'))?.languageKey || 'fa';

  const existDirection =
    getLanguage()?.isRtl ||
    // @ts-ignore
    JSON.parse(localStorage.getItem('localization'))?.isRtl;

  const direction: 'rtl' | 'ltr' = (function () {
    if (existDirection == true) {
      return 'rtl';
    } else if (existDirection == false) {
      return 'ltr';
    } else {
      return 'rtl';
    }
  })();
  // const direction: "rtl" | "ltr" = (function () {
  //   if (t(key) == "rtl") {
  //     return "rtl";
  //   } else if (t(key) == "ltr") {
  //     return "ltr";
  //   } else {
  //     return "rtl";
  //   }
  // })();
  // t(key) || "rtl";
  const isRtl = direction == 'rtl';
  const styler = (style: React.CSSProperties) => {
    let newStyle: React.CSSProperties = style;
    if (!isRtl) {
      for (let [key, value] of Object.entries(style)) {
        switch (key) {
          case 'textAlign':
            newStyle = {
              ...newStyle,
              textAlign: newStyle.textAlign == 'right' ? 'left' : 'right',
            };
            break;
          case 'right':
            delete newStyle.right;
            newStyle = { ...newStyle, left: value };
            break;
          case 'left':
            delete newStyle.left;
            newStyle = { ...newStyle, right: value };
            break;
          case 'marginRight':
            delete newStyle.marginRight;
            newStyle = { ...newStyle, marginLeft: value };
            break;
          case 'marginLeft':
            delete newStyle.marginRight;
            newStyle = { ...newStyle, marginRight: value };
            break;
          case 'paddingRight':
            delete newStyle.paddingRight;
            newStyle = { ...newStyle, paddingLeft: value };
            break;

          case 'paddingLeft':
            delete newStyle.paddingLeft;
            newStyle = { ...newStyle, paddingRight: value };
            break;
        }
      }
    }

    return newStyle;
  };
  const priceSeprator = (
    price: number | string,
    showSymbol: boolean = true,
    currency?: string
  ) => {
    return (price || price == 0) && String(price).length
      ? `${String(Number(price).toFixed(0))} ${
          showSymbol
            ? currency ||
              ((pathname?.includes('panel') &&
                (hasRole(RoleEnum.end_user) ||
                  hasRole(RoleEnum.tagrani_user))) ||
              !pathname?.includes('panel')
                ? getCurrency()?.currencySymbol
                : symbol_native)
            : ''
        }`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : null;
  };
  return { direction, isRtl, styler, lng, priceSeprator };
};
export default useDirection;
